<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<ng-container *ngIf="screen.request"
					><div
						class="layout-block"
						[style.align-items]="'inherit'"
						[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
						[style.--layout-column-count]="2"
						[style.gap]="'1em'"
					>
						<mat-card [style.grid-column]="'span ' + (1)">
							<mat-card-header>
								<mat-card-title
									><span
										[innerHtml]="'E-mail from customer' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></mat-card-title>
								<mat-card-subtitle
									><span
										[innerHtml]="screen.request.subject | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></mat-card-subtitle>
							</mat-card-header>

							<mat-card-content>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<div
										class="layout-block"
										[style.align-items]="'inherit'"
										[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
										[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
										[style.gap]="'1em'"
									>
										<span
											[style.flex]="'1 0 auto'"
											[innerHtml]="`From: ${screen.request.customerEmail}` | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
										<span
											[innerHtml]="Sys.Date.format(screen.request.createdOn, 'dd.MM.yy, HH:mm') | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</div>
									<span
										style="margin-top: 1em"
										[innerHtml]="screen.request.requestHtml | escapeHtml: 'safe' | replaceNewlines: 'span'"
									></span>
								</div>
							</mat-card-content>
						</mat-card>
						<mat-card [style.grid-column]="'span ' + (1)">
							<mat-card-header>
								<mat-card-title
									><span
										[innerHtml]="'Drawings' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span
								></mat-card-title>
							</mat-card-header>

							<mat-card-content>
								<ng-container
									*ngIf="screen.request.attachments?.length; else else32"
									><mat-tab-group
										#$tabGroupControl_49="lowgileTabGroupControl"
										lowgileSelectedTab
										[animationDuration]="300 + 'ms'"
										[mat-stretch-tabs]="false"
									>
										<ng-container
											*ngFor="let drawing of screen.request.attachments; let drawingIndex = index; trackBy: trackByAutomatic"
										>
											<ng-container
												*lowgileScope="drawing; as: 'drawing'; let $scope"
											>
												<ng-container
													*lowgileScope="drawingIndex; as: 'drawingIndex'; let $scope"
												>
													<mat-tab
														[label]="drawing.fileName"
														[lowgileTabName]="''"
													>
														<ng-template matTabContent>
															@let isPdf = _ScopeBlock_var_isPdf_107({
															app, screen, $pathSegments, $disabled,
															drawing, drawingIndex });
															<ng-container
																*lowgileScope="isPdf; as: 'isPdf'; let $scope"
															>
																<div
																	class="layout-block"
																	[style.align-items]="'baseline'"
																	[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																	[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																	[style.gap]="'1em'"
																>
																	<mat-form-field
																		appearance="fill"
																	>
																		@let $fc_106_1 =
																		getFormControl(drawing,
																		'fileName', 106, $scope,
																		$formDirective, $disabled,
																		$ignoreValidations);
																		<mat-label
																			[innerHtml]="'File name' | escapeHtml"
																		></mat-label>
																		<input
																			#input_106
																			[formControl]="$fc_106_1"
																			type="text"
																			matInput
																		/>
																	</mat-form-field>

																	<ng-container *ngIf="isPdf">
																		<div>
																			@let $fc_73_1 =
																			getFormControl(screen,
																			'showRedact', 73,
																			$scope, $formDirective,
																			$disabled,
																			$ignoreValidations);
																			<mat-checkbox
																				appearance="fill"
																				[formControl]="$fc_73_1"
																			>
																				{{ 'Redaction mode'
																				}}
																			</mat-checkbox>
																		</div></ng-container
																	>

																	<ng-container
																		*ngIf="drawing.data?.data"
																		><ng-container
																			*ngrxLet="(!devBarService.isEnableEverything()) && (!!(false)) as $disabled"
																		>
																			<button
																				mat-icon-button
																				mat-small-icon-button
																				class="has-click-handler"
																				color="basic"
																				(click)="handler_ButtonBlock_139_click_$adhoc_0($event, { drawing, drawingIndex, isPdf, $disabled: $disabled })"
																				[disabled]="$disabled"
																			>
																				<mat-icon
																					>{{'download'}}</mat-icon
																				>
																			</button>
																		</ng-container></ng-container
																	>
																</div>
																<ng-container *ngIf="isPdf"
																	>@defer (on immediate) {
																	<lowgile-pdf
																		style="width: 500px"
																		[url]=""
																		[base64Src]="drawing.data.data | base64"
																		[height]="'500px'"
																		[redactionMode]="screen.showRedact"
																		[(redactions)]="drawing.redactionBoxes"
																	></lowgile-pdf>
																	}</ng-container
																>

																<ng-container
																	*ngIf="drawing?.mimeType?.startsWith('image/')"
																	><img
																		style="max-width: 100%"
																		[src]="drawing.data.data | arrayBufferSrc : 'image/*'"
																/></ng-container>
															</ng-container>
														</ng-template>
													</mat-tab>
												</ng-container>
											</ng-container>
										</ng-container> </mat-tab-group
								></ng-container>
								<ng-template #else32>
									<span
										style="font-style: italic"
										[innerHtml]="'no attachments sent along' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
								</ng-template>
							</mat-card-content>
						</mat-card>
					</div>

					<mat-expansion-panel
						[expanded]="false"
						style="margin: 0.5em"
						[hideToggle]="!(true)"
					>
						<mat-expansion-panel-header>
							<mat-panel-title>
								<span
									[innerHtml]="'Customer history' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent
							><Orders-CustomerHistoryInclude
								[$formDirective]="$formDirective"
								[$disabled]="$disabled"
								[$ignoreValidations]="$ignoreValidations"
								[customerDomain]="screen.request.customerDomain"
								[referenceRequest]="screen.request"
							>
							</Orders-CustomerHistoryInclude
						></ng-template>
					</mat-expansion-panel>

					<mat-card>
						<mat-card-header>
							<mat-card-title
								><span
									[innerHtml]="'Requested items' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></mat-card-title>
						</mat-card-header>

						<mat-card-content>
							<lowgile-table
								#datatable_55
								[dataSignal]="_DataTableBlock_collectionCodeSignal_55(datatable_55, { app, screen, $pathSegments, $disabled })"
								[trackBy]="trackByAutomatic"
								[columns]="_DataTableBlock_columns_55(screen)"
								[showSettings]="false"
								[userDefinedConfiguration]="undefined"
								[usePaging]="false"
								[pageSize]="999"
								[pageSizeOptions]="[10, 20, 50]"
								[useGlobalFilter]="false"
								[debouncingDelay]="250"
								[stickyHeader]="true"
								[additionalFindOptions]="_DataTableBlock_additionalFindOptions_55({ app, screen, $pathSegments, $disabled })"
								[additionalHeaderRows]="[]"
								[additionalFooterRows]="[]"
								[allClasses]="$Modules"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[surroundingScope]="$scope"
								#$table_55="lowgileTable"
							>
								<ng-container [lowgile-column]="'name'">
									<th mat-header-cell *matHeaderCellDef>
										<span
											[innerHtml]="'Item' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</th>
									<td
										mat-cell
										*matCellDef="let item; let itemIndex = index"
										[attr.data-label]="'Item'"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<mat-form-field class="fill" appearance="fill">
													@let $fc_97_1 = getFormControl(item, 'name', 97,
													$scope, $formDirective, $disabled,
													$ignoreValidations);
													<mat-label
														[innerHtml]="'' | escapeHtml"
													></mat-label>
													<input
														#input_97
														[formControl]="$fc_97_1"
														type="text"
														matInput
													/>
												</mat-form-field>
											</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<ng-container [lowgile-column]="('name') + '$$filter'">
									<th mat-header-cell *matHeaderCellDef></th>
								</ng-container>

								<ng-container [lowgile-column]="'method'">
									<th mat-header-cell *matHeaderCellDef>
										<span
											[innerHtml]="'Processing method' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</th>
									<td
										mat-cell
										*matCellDef="let item; let itemIndex = index"
										[attr.data-label]="'Processing method'"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<mat-form-field class="fill" appearance="fill">
													@let $fc_121_1 = getFormControl(item,
													'processingMethod', 121, $scope, $formDirective,
													$disabled, $ignoreValidations);

													<mat-label
														[innerHtml]="'' | escapeHtml"
													></mat-label>
													<mat-select
														[formControl]="$fc_121_1"
														[compareWith]="$compare"
														#select_121="matSelect"
														[lgFormComponent]="select_121"
														[lgFormValue]="item.processingMethod"
														canSelectNullableOptions
														[multiple]="false"
													>
														@let emptyOption_121 = null; @if
														(emptyOption_121) {
														<mat-option [value]="emptyOption_121[0]"
															>{{ emptyOption_121[1] }}</mat-option
														>
														}

														<mat-option
															*ngFor="let $option of (Orders.ProcessingMethod.getChoices('$displayValue')); let $index = index"
															[value]="Orders.ProcessingMethod.getEntry($option.id)"
														>
															<span
																[innerHtml]="$option.label | escapeHtml"
																style="margin: auto 0"
															></span>
														</mat-option>
													</mat-select>
												</mat-form-field>
												<mat-form-field
													*ngIf="$any(item.processingMethod)?.$isOther"
												>
													@let $fc_121_3 =
													getFormControl(item.processingMethod,
													'$otherValue', 121, $scope, $formDirective,
													$disabled, $ignoreValidations);
													<mat-label
														[innerHtml]="'' + ' (Other)' | escapeHtml"
													></mat-label>
													<input
														type="text"
														matInput
														[formControl]="$fc_121_3"
													/>
												</mat-form-field>
											</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<ng-container [lowgile-column]="('method') + '$$filter'">
									<th mat-header-cell *matHeaderCellDef></th>
								</ng-container>

								<ng-container [lowgile-column]="'dimensions'">
									<th mat-header-cell *matHeaderCellDef>
										<span
											[innerHtml]="'Dimensions' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</th>
									<td
										mat-cell
										*matCellDef="let item; let itemIndex = index"
										[attr.data-label]="'Dimensions'"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<mat-form-field class="fill" appearance="fill">
													@let $fc_122_1 = getFormControl(item,
													'dimensions', 122, $scope, $formDirective,
													$disabled, $ignoreValidations);
													<mat-label
														[innerHtml]="'' | escapeHtml"
													></mat-label>
													<input
														#input_122
														[formControl]="$fc_122_1"
														type="text"
														matInput
													/>
												</mat-form-field>
											</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<ng-container [lowgile-column]="('dimensions') + '$$filter'">
									<th mat-header-cell *matHeaderCellDef></th>
								</ng-container>

								<ng-container [lowgile-column]="'quantities'">
									<th mat-header-cell *matHeaderCellDef>
										<span
											[innerHtml]="'Quantities' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</th>
									<td
										mat-cell
										*matCellDef="let item; let itemIndex = index"
										[attr.data-label]="'Quantities'"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<mat-form-field class="fill">
													<mat-label
														[innerHtml]="'' | escapeHtml"
													></mat-label>
													<mat-chip-grid #chipGrid_104>
														@for(quantity of item.quantities; track
														$index; let quantityIndex = $index) { @if
														(true) {
														<mat-chip-row
															class="has-chip-removed-handler"
															(removed)="handler_ChipGroupBlock_104_chip_removed_$adhoc_0($event, { item, itemIndex, quantity, quantityIndex, $disabled: $disabled })"
															[disabled]="$disabled"
														>
															<ng-container
																*lowgileScope="quantity; as: 'quantity'; let $scope"
															>
																<ng-container
																	*lowgileScope="quantityIndex; as: 'quantityIndex'; let $scope"
																>
																	<span
																		[innerHtml]="quantity | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
															@if ((true) && !$disabled) {
															<button matChipRemove>
																<mat-icon>cancel</mat-icon>
															</button>
															}
														</mat-chip-row>
														} }
													</mat-chip-grid>
													@if (!$disabled) {
													<input
														#input_104
														[placeholder]="'Add quantity'"
														[matChipInputFor]="chipGrid_104"
														class="has-input-matChipInputTokenEnd-handler"
														(matChipInputTokenEnd)="handler_ChipGroupBlock_104_input_matChipInputTokenEnd_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
													/>

													}
												</mat-form-field>
											</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<ng-container [lowgile-column]="('quantities') + '$$filter'">
									<th mat-header-cell *matHeaderCellDef></th>
								</ng-container>

								<ng-container [lowgile-column]="'attachments'">
									<th mat-header-cell *matHeaderCellDef>
										<span
											[innerHtml]="'Related attachments' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</th>
									<td
										mat-cell
										*matCellDef="let item; let itemIndex = index"
										[attr.data-label]="'Related attachments'"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<mat-form-field class="fill">
													<mat-label
														[innerHtml]="'' | escapeHtml"
													></mat-label>
													<mat-chip-grid #chipGrid_109>
														@for(attachment of
														screen.request.attachments; track $index;
														let attachmentIndex = $index) { @if
														(item.relatedAttachmentIds.includes(attachment.id))
														{
														<mat-chip-row
															class="has-chip-removed-handler"
															(removed)="handler_ChipGroupBlock_109_chip_removed_$adhoc_0($event, { item, itemIndex, attachment, attachmentIndex, $disabled: $disabled })"
															[disabled]="$disabled"
														>
															<ng-container
																*lowgileScope="attachment; as: 'attachment'; let $scope"
															>
																<ng-container
																	*lowgileScope="attachmentIndex; as: 'attachmentIndex'; let $scope"
																>
																	<span
																		[innerHtml]="attachment.fileName | escapeHtml: 'none' | replaceNewlines: 'span'"
																	></span>
																</ng-container>
															</ng-container>
															@if ((true) && !$disabled) {
															<button matChipRemove>
																<mat-icon>cancel</mat-icon>
															</button>
															}
														</mat-chip-row>
														} }
													</mat-chip-grid>
													@if (!$disabled) {
													<input
														#input_109
														[placeholder]="'Add attachment'"
														[matChipInputFor]="chipGrid_109"
														[matAutocomplete]="auto_109"
													/>

													<mat-autocomplete
														#auto_109
														class="has-dropdown-optionSelected-handler"
														(optionSelected)="handler_ChipGroupBlock_109_dropdown_optionSelected_$adhoc_0($event, { item, itemIndex, $disabled: $disabled }); 
				input_109.value = ''
			"
													>
														@for(attachment of
														screen.request.attachments; track
														attachment; let attachmentIndex = $index) {
														@if(!(item.relatedAttachmentIds.includes(attachment.id)))
														{
														<mat-option [value]="attachment.id"
															>{{attachment.fileName}}</mat-option
														>
														} }
													</mat-autocomplete>

													}
												</mat-form-field>
											</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<ng-container [lowgile-column]="('attachments') + '$$filter'">
									<th mat-header-cell *matHeaderCellDef></th>
								</ng-container>

								<ng-container [lowgile-column]="'materials'">
									<th mat-header-cell *matHeaderCellDef>
										<span
											[innerHtml]="'materials' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</th>
									<td
										mat-cell
										*matCellDef="let item; let itemIndex = index"
										[attr.data-label]="'materials'"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<div
													class="layout-block vertical"
													[style.align-items]="'inherit'"
													[style.gap]="'1em'"
												>
													<ng-container
														*ngFor="let itemMaterial of item.materials; let itemMaterialIndex = index; trackBy: trackByAutomatic"
													>
														<ng-container
															*lowgileScope="itemMaterial; as: 'itemMaterial'; let $scope"
														>
															<ng-container
																*lowgileScope="itemMaterialIndex; as: 'itemMaterialIndex'; let $scope"
															>
																<div
																	class="layout-block"
																	[style.border-top]="itemMaterialIndex ? '1px solid lightgray' : ''"
																	[style.align-items]="'inherit'"
																	[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																	[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																	[style.gap]="'1em'"
																>
																	<ng-container *ngIf="!$disabled"
																		><button
																			mat-icon-button
																			mat-small-icon-button
																			class="has-click-handler"
																			color="basic"
																			(click)="handler_ButtonBlock_43_click_$adhoc_0($event, { item, itemIndex, itemMaterial, itemMaterialIndex, $disabled: $disabled }); handler_ButtonBlock_43_click_recalculateVendors_1($event, { item, itemIndex, itemMaterial, itemMaterialIndex, $disabled: $disabled })"
																			[disabled]="$disabled"
																		>
																			<mat-icon
																				>{{'delete'}}</mat-icon
																			>
																		</button></ng-container
																	>

																	<div
																		class="layout-block vertical"
																		[style.align-items]="'inherit'"
																		[style.gap]="'1em'"
																	>
																		<span
																			[innerHtml]="itemMaterial.name | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																		<ng-container
																			*ngIf="itemMaterial.materialAsMentionedInDrawing"
																			><span
																				style="
																					font-size: 70%;
																				"
																				[innerHtml]="`\&quot;${itemMaterial.materialAsMentionedInDrawing}\&quot; at ${itemMaterial.whereMaterialWasMentioned}` | escapeHtml: 'none' | replaceNewlines: 'span'"
																			></span
																		></ng-container>
																	</div>
																</div>
															</ng-container>
														</ng-container>
													</ng-container>
													<ng-container *ngIf="!$disabled"
														><ng-container
															*ngIf="screen.addMaterialParsedItemIdx == itemIndex; else else45"
															>@let $fc_44_1 = getFormControl(screen,
															'addMaterial', 44, $scope,
															$formDirective, $disabled,
															$ignoreValidations); @let displayWith_44
															=
															_SearchableDropdownBlock_displayWith_44;
															<lowgile-searchable-dropdown
																class="has-optionSelected-handler"
																appearance="fill"
																(optionSelected)="handler_SearchableDropdownBlock_44_optionSelected_$adhoc_0($event, { item, itemIndex, $disabled: $disabled }); handler_SearchableDropdownBlock_44_optionSelected_recalculateVendors_1($event, { item, itemIndex, $disabled: $disabled })"
																[data]="_SearchableDropdownBlock_collectionCode_44($scope)"
																[trackBy]="trackByAutomatic"
																[label]="'Add material'"
																[formControl]="$fc_44_1"
																bindingMode="object"
																[entity]=""
																[minSearchLength]="0"
																[maxResults]="20"
																[displayWith]="displayWith_44"
																[displayWithContext]="$scope"
																[debouncingDelayMs]="250"
																[findOptions]="null"
																[allowClearing]="true"
																[allClasses]="$Modules"
																[emptySelection]="undefined"
																[itemTemplate]="itemTemplate_44"
															></lowgile-searchable-dropdown>
															<ng-template
																#itemTemplate_44
																let-$option
																let-$index="$index"
															>
																{{ displayWith_44($option, $index,
																$scope) }}
															</ng-template>
														</ng-container>
														<ng-template #else45>
															<button
																mat-icon-button
																mat-small-icon-button
																class="has-click-handler"
																color="basic"
																(click)="handler_ButtonBlock_56_click_$adhoc_0($event, { item, itemIndex, $disabled: $disabled })"
																[disabled]="$disabled"
															>
																<mat-icon
																	>{{'add_circle'}}</mat-icon
																>
															</button>
														</ng-template></ng-container
													>
												</div>
											</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<ng-container [lowgile-column]="('materials') + '$$filter'">
									<th mat-header-cell *matHeaderCellDef></th>
								</ng-container>
							</lowgile-table>
						</mat-card-content>
					</mat-card>
					<mat-card>
						<mat-card-header>
							<mat-card-title
								><span
									[innerHtml]="'Vendors to ask for offer' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></mat-card-title>
						</mat-card-header>

						<mat-card-content>
							<div
								class="layout-block"
								[style.align-items]="'start'"
								[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
								[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
								[style.--layout-column-count]="2"
								[style.gap]="'1em'"
							>
								<div
									class="layout-block"
									[style.grid-column]="'span ' + (1)"
									[style.align-items]="'stretch'"
									[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.--layout-column-count]="screen.request.items.length + 1"
									[style.gap]="'0.25 em 0.5em'"
								>
									<span
										[style.grid-column]="'span ' + (1)"
										[innerHtml]="'&nbsp;' | escapeHtml: 'safe' | replaceNewlines: 'span'"
									></span>
									<ng-container
										*ngFor="let item of screen.request.items; let itemIndex = index; trackBy: trackByAutomatic"
									>
										<ng-container *lowgileScope="item; as: 'item'; let $scope">
											<ng-container
												*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
											>
												<div
													class="layout-block vertical"
													style="
														border-left: 1px solid lightgray;
														padding: 0 12px 5px;
													"
													[style.grid-column]="'span ' + (1)"
													[style.align-items]="'inherit'"
													[style.gap]="'0.25em'"
												>
													<span
														[innerHtml]="item.name | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
													<span
														style="font-size: 70%; font-style: italic"
														[innerHtml]="item.materials.map(m => m.name).join(' / ') | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</div>
											</ng-container>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="screen.request.vendorSelection"
										><ng-container
											*ngFor="let vendor of screen.matchingVendors; let vendorIndex = index; trackBy: trackByAutomatic"
										>
											<ng-container
												*lowgileScope="vendor; as: 'vendor'; let $scope"
											>
												<ng-container
													*lowgileScope="vendorIndex; as: 'vendorIndex'; let $scope"
												>
													<div
														class="layout-block vertical"
														style="border-top: 1px solid lightgray"
														[style.grid-column]="'span ' + (1)"
														[style.align-items]="'inherit'"
														[style.gap]="'1em'"
													>
														<mat-expansion-panel
															[expanded]="false"
															style="margin: 0.5em"
															[hideToggle]="!(true)"
														>
															<mat-expansion-panel-header>
																<mat-panel-title>
																	<div
																		class="layout-block fill"
																		[style.align-items]="'inherit'"
																		[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																		[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																		[style.gap]="'1em'"
																	>
																		<span
																			[style.flex]="'1 0 auto'"
																			[innerHtml]="vendor.name | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																		<span
																			style="
																				margin-right: 1em;
																			"
																			[innerHtml]="vendor.language.flag | escapeHtml: 'none' | replaceNewlines: 'span'"
																		></span>
																	</div>
																</mat-panel-title>
															</mat-expansion-panel-header>
															<ng-template matExpansionPanelContent
																><Orders-VendorHistoryInclude
																	[$formDirective]="$formDirective"
																	[$disabled]="$disabled"
																	[$ignoreValidations]="$ignoreValidations"
																	[referenceRequest]="screen.request"
																	[vendorId]="vendor.id"
																>
																</Orders-VendorHistoryInclude
															></ng-template>
														</mat-expansion-panel>
													</div>
													<ng-container
														*ngFor="let item of screen.request.items; let itemIndex = index; trackBy: trackByAutomatic"
													>
														<ng-container
															*lowgileScope="item; as: 'item'; let $scope"
														>
															<ng-container
																*lowgileScope="itemIndex; as: 'itemIndex'; let $scope"
															>
																<div
																	class="layout-block"
																	style="
																		border-top: 1px solid
																			lightgray;
																		border-left: 1px solid
																			lightgray;
																	"
																	[style.grid-column]="'span ' + (1)"
																	[style.align-items]="'center'"
																	[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
																	[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
																	[style.gap]="'0'"
																>
																	<ng-container
																		*ngIf="screen.request.vendorSelection[vendor.id]?.[item.id] != undefined"
																	>
																		<div>
																			@let $fc_89_1 =
																			getFormControl(screen.request.vendorSelection[vendor.id],
																			item.id, 89, $scope,
																			$formDirective,
																			$disabled,
																			$ignoreValidations);
																			<mat-checkbox
																				appearance="outline"
																				style="
																					height: 40px;
																					padding-top: 8px;
																				"
																				[formControl]="$fc_89_1"
																			>
																				{{ '' }}
																			</mat-checkbox>
																		</div>
																		<ng-container
																			*ngIf="vendor[item.processingMethod.id]"
																			><mat-icon
																				[innerHtml]="'hotel_class'"
																				fontSet="material-icons"
																				[inline]="false"
																			></mat-icon
																		></ng-container>
																	</ng-container>
																</div>
															</ng-container>
														</ng-container>
													</ng-container>
												</ng-container>
											</ng-container> </ng-container
									></ng-container>
								</div>
								<div
									class="layout-block vertical"
									[style.grid-column]="'span ' + (1)"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="!$disabled"
										><button
											mat-raised-button
											class="has-click-handler"
											color="basic"
											(click)="handler_ButtonBlock_75_click_$adhoc_0($event, { $disabled: $disabled })"
											[disabled]="$disabled"
										>
											<mat-icon>{{'create'}}</mat-icon
											><span
												[innerHtml]="'Fill in request templates' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span></button
									></ng-container>

									<mat-tab-group
										#$tabGroupControl_79="lowgileTabGroupControl"
										lowgileSelectedTab
										[animationDuration]="300 + 'ms'"
										[mat-stretch-tabs]="false"
									>
										<ng-container
											*ngFor="let language of _ForBlock_collectionCode_81({ app, screen, $pathSegments, $disabled }); let languageIndex = index; trackBy: trackByAutomatic"
										>
											<ng-container
												*lowgileScope="language; as: 'language'; let $scope"
											>
												<ng-container
													*lowgileScope="languageIndex; as: 'languageIndex'; let $scope"
												>
													<mat-tab
														[label]="language.label"
														[lowgileTabName]="''"
													>
														@let $fc_61_1 =
														getFormControl(screen.request.vendorRequestHtmls,
														language.id, 61, $scope, $formDirective,
														$disabled, $ignoreValidations);
														<div>
															<lowgile-rich-text-editor
																[formControl]="$fc_61_1"
															/>
															<div
																style="
																	color: var(
																		--mat-form-field-error-text-color
																	);
																"
															></div>
														</div>
													</mat-tab>
												</ng-container>
											</ng-container>
										</ng-container>
									</mat-tab-group>
								</div>
							</div>
						</mat-card-content>
					</mat-card>
					<mat-card>
						<mat-card-header>
							<mat-card-title
								><span
									[innerHtml]="'Additional information' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></mat-card-title>
						</mat-card-header>

						<mat-card-content>
							<div
								class="layout-block vertical"
								[style.align-items]="'inherit'"
								[style.gap]="'1em'"
							>
								<mat-form-field class="fill" appearance="fill">
									@let $fc_136_1 = getFormControl(screen.request, 'comment', 136,
									$scope, $formDirective, $disabled, $ignoreValidations);
									<mat-label [innerHtml]="'Comment' | escapeHtml"></mat-label>
									<textarea
										#input_136
										[formControl]="$fc_136_1"
										matInput
										[rows]="3"
									></textarea>
								</mat-form-field>

								<mat-form-field
									class="has-click-handler"
									appearance="fill"
									(click)="handler_InputBlock_137_click_$adhoc_0($event, { $disabled: $disabled })"
								>
									@let $fc_137_1 = getFormControl(screen.request, 'projectNumber',
									137, $scope, $formDirective, $disabled, $ignoreValidations);
									<mat-label
										[innerHtml]="'Project number' | escapeHtml"
									></mat-label>
									<input
										#input_137
										[formControl]="$fc_137_1"
										type="text"
										matInput
										class="has-click-handler"
										(click)="handler_InputBlock_137_click_$adhoc_0($event, { $disabled: $disabled })"
										[required]="!$ignoreValidations"
									/>

									@for(error of $fc_137_1.errors ?? {} | keyvalue; track
									error.key) {
									<mat-error
										*ngIf="typeof error.value == 'string'"
										[innerHtml]="error.value | escapeHtml: 'safe'"
									/>
									}

									<mat-hint
										><span
											[innerHtml]="'e.g. 2026123456' | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span
									></mat-hint>
								</mat-form-field>
							</div>
						</mat-card-content> </mat-card
				></ng-container>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
